import { render, staticRenderFns } from "./NavbarPayment.vue?vue&type=template&id=01874500&scoped=true"
import script from "./NavbarPayment.vue?vue&type=script&lang=js"
export * from "./NavbarPayment.vue?vue&type=script&lang=js"
import style0 from "./NavbarPayment.vue?vue&type=style&index=0&id=01874500&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01874500",
  null
  
)

export default component.exports